import i18next from 'i18next';

i18next.addResources('es_CL', 'LoginForm', {
  user: 'Email',
  password: 'Contraseña',
  login: 'Iniciar sesión',
  loginIn: 'Iniciando sesión...',
  forgotPassword: 'Olvidaste tu contraseña?',
  loginError: 'El email o la contraseña son inválidos.',
  missingTenantError: 'No pudimos identificar tu compañía. Contacta a soporte.'
});

i18next.addResources('es_CR', 'LoginForm', {
  user: 'Email',
  password: 'Contraseña',
  login: 'Iniciar sesión',
  loginIn: 'Iniciando sesión...',
  forgotPassword: 'Olvidaste tu contraseña?',
  loginError: 'El email o la contraseña son inválidos.',
  missingTenantError: 'No pudimos identificar tu compañía. Contacta a soporte.'
});
